// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_b6-0";
export var orangeButton = "_b6-1";